/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { AnalysisFilterDto } from '../models/AnalysisFilterDto';
import type { CommentCountResponseDto } from '../models/CommentCountResponseDto';
import type { CommentsAIAnalysisRequestDto } from '../models/CommentsAIAnalysisRequestDto';
import type { CommentsRequestDto } from '../models/CommentsRequestDto';
import type { CommentsResponseDto } from '../models/CommentsResponseDto';
import type { CommentsTopicsDto } from '../models/CommentsTopicsDto';
import type { GetSentimentDto } from '../models/GetSentimentDto';
import type { PaginatedCommentsResponseDto } from '../models/PaginatedCommentsResponseDto';
import type { QuestionCommentFilterPagedDto } from '../models/QuestionCommentFilterPagedDto';
import type { QuestionCommentPagedRequest } from '../models/QuestionCommentPagedRequest';
import type { SectionSentimentDto } from '../models/SectionSentimentDto';
import type { SentimentDto } from '../models/SentimentDto';
import type { UpdateSentimentDto } from '../models/UpdateSentimentDto';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class CommentAiService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param requestBody 
     * @returns SentimentDto Success
     * @throws ApiError
     */
    public getSentiment(
requestBody?: GetSentimentDto,
): Observable<SentimentDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/sentiment',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param formId 
     * @returns string Success
     * @throws ApiError
     */
    public getExistingTopics(
formId: string,
): Observable<Array<string>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/comment-ai/topics/simple/{formId}',
            path: {
                'formId': formId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns QuestionCommentFilterPagedDto Success
     * @throws ApiError
     */
    public getPaginatedComments(
requestBody?: QuestionCommentPagedRequest,
): Observable<QuestionCommentFilterPagedDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/comments/paginated',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns CommentsResponseDto Success
     * @throws ApiError
     */
    public getComments(
requestBody?: CommentsRequestDto,
): Observable<CommentsResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/comments',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param formId 
     * @param requestBody 
     * @returns PaginatedCommentsResponseDto Success
     * @throws ApiError
     */
    public getSectionCommentCount(
formId?: string,
requestBody?: Array<AnalysisFilterDto>,
): Observable<PaginatedCommentsResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/section/comments/count',
            query: {
                'formId': formId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns SectionSentimentDto Success
     * @throws ApiError
     */
    public getCommentsAiAnalysis(
requestBody?: CommentsAIAnalysisRequestDto,
): Observable<Array<SectionSentimentDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/comments-ai-analysis',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public updateCommentsAi(
requestBody?: UpdateSentimentDto,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/comments-update-sentiment',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param formId 
     * @param requestBody 
     * @returns CommentsTopicsDto Success
     * @throws ApiError
     */
    public getCommentsTopicsList(
formId: string,
requestBody?: Array<AnalysisFilterDto>,
): Observable<Array<CommentsTopicsDto>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/comments-ai-topics/{formId}',
            path: {
                'formId': formId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param surveyKey 
     * @param requestBody 
     * @returns CommentCountResponseDto Success
     * @throws ApiError
     */
    public getSectionsCommentCount(
surveyKey: string,
requestBody?: Array<AnalysisFilterDto>,
): Observable<CommentCountResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/comment-ai/sections-comments-count/{surveyKey}',
            path: {
                'surveyKey': surveyKey,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
